import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { findTerm } from "@/data/glossary";
import { BookOpen } from "lucide-react";

// <G>yield-on-cost</G>  →  underlined dotted span; hover/click reveals definition.
// The child text is what displays; the lookup key defaults to that text but can
// be overridden with the `term` prop when the visible word differs from the
// glossary entry (e.g. <G term="DRIP">reinvestment</G>).
export function G({ children, term }) {
  const key = term || (typeof children === "string" ? children : "");
  const entry = findTerm(key);
  if (!entry) return <>{children}</>;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="underline decoration-dotted decoration-secondary underline-offset-4 hover:text-secondary transition-colors cursor-help"
          data-testid={`gterm-${entry.term.toLowerCase().replace(/\s+/g, "-")}`}
        >
          {children}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 text-sm" side="top" align="center">
        <div className="flex items-center gap-1.5 mb-1.5">
          <BookOpen className="w-3.5 h-3.5 text-secondary" />
          <div className="mono text-[10px] uppercase tracking-widest text-secondary">{entry.term}</div>
        </div>
        <p className="leading-relaxed text-foreground/85">{entry.definition}</p>
      </PopoverContent>
    </Popover>
  );
}

export default G;
